
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";

@Component({
  components: {
    PIcon,
  },
})
export class PSidebar extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Watch("value", { immediate: true })
  onChangeValue(): void {
    this.showSidebar = this.value;
  }
  @Prop({ required: false, default: "" }) width!: string;
  @Prop({ required: false, default: "" }) title!: string;

  showSidebar = false;

  get widthComp(): string {
    return this.width != "" ? "width:" + this.width + ";" : "";
  }

  close(): void {
    this.showSidebar = false;
    this.$emit("input", this.showSidebar);
  }
}
export default PSidebar;
